import { useParams } from 'react-router-dom';
import Viewer from './components/Viewer';
import './App.css';

export default function App() {
  const { slug } = useParams();
  return <Viewer clientSlug={slug} />;
}
